import React, { useEffect, useState } from 'react';

// material-ui
// project imports
import NavGroup from './NavGroup';
import packageJson from '../../../../../package.json';
import menuItem from '../../../menuItens';
import { useSelector } from 'react-redux';
import { Box, styled, Typography } from '@mui/material';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const DivVersao = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerOpen' })`
  position: fixed;
  display: flex;
  justify-content: center;
  left: 0;
  width: ${props => props.drawerOpen ? "260px" : "88px"};
  top: 97%;
  color: #c3c3c3;
  font-size: 16px;
  padding-bottom: 10px;
`;

const MenuList = () => {
  const leftDrawerOpened = useSelector((state) => state.customization.opened);

  const menu = menuItem.items;

  const navItems = menu.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  navItems.push(<div key='rodape'>
    {leftDrawerOpened && <DivVersao drawerOpen={leftDrawerOpened}>Versão: {packageJson.version} </DivVersao>}
    {!leftDrawerOpened && <DivVersao drawerOpen={leftDrawerOpened}>V: {packageJson.version} </DivVersao>}
  </div>);

  return <>{navItems}</>;
};

export default MenuList;
